import { render, staticRenderFns } from "./ResponsiveNavigation.vue?vue&type=template&id=86b0c42a&"
import script from "./ResponsiveNavigation.vue?vue&type=script&lang=js&"
export * from "./ResponsiveNavigation.vue?vue&type=script&lang=js&"
import style0 from "./ResponsiveNavigation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/studip/studip/studip/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('86b0c42a')) {
      api.createRecord('86b0c42a', component.options)
    } else {
      api.reload('86b0c42a', component.options)
    }
    module.hot.accept("./ResponsiveNavigation.vue?vue&type=template&id=86b0c42a&", function () {
      api.rerender('86b0c42a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/vue/components/responsive/ResponsiveNavigation.vue"
export default component.exports